import React, { useState, useEffect } from 'react';
import Modal from 'cccisd-modal';
import Clipboard from 'cccisd-icons/clipboard4';
import Tooltip from 'cccisd-tooltip';

const LastUpdatedBy = props => {
    const [values, setValues] = useState(null);

    const annualLabels = {
        'lastUpdatedBy.app_variable_lastUpdatedBy': 'Engagment Plan',

        'devTags.LastUpdatedByProgram': 'Programatic Information',

        'devTags.LastUpdatedByQ1': 'Quarter 1 Progress',

        'devTags.LastUpdatedByQ2': 'Quarter 2 Progress',

        'devTags.LastUpdatedByQ3': 'Quarter 3 Progress',

        'devTags.LastUpdatedByQ4': 'Quarter 4 Progress',
    };

    const orgStaffLabels = {
        'lastUpdatedBy2.app_variable_lastUpdatedBy': 'Organization Information',
        'otherUpdatedBy.221_app_variable_lastUpdatedBy': 'Staff Information',
    };
    const orgStaffTags = {
        'lastUpdatedBy2.app_variable_lastUpdatedBy': 'devTags.OrgInfoLastUpdatedDate',
        'otherUpdatedBy.221_app_variable_lastUpdatedBy': 'devTags.SummaryLastUpdatedDate',
    };
    useEffect(() => {
        // will refactor later - expect more surveys to use this render w/ different label sets
        if (props.isAnnual) {
            const arr = [];
            for (const [key, value] of Object.entries(annualLabels)) {
                const match = props.row[key];
                if (match) {
                    arr.push({ value, match });
                }
            }
            setValues(arr);
        }

        if (props.isOrgInfo) {
            const arr = [];
            for (const [key, value] of Object.entries(orgStaffLabels)) {
                const match = props.row[key];
                const nameArr = match?.split(',');

                const dateArr = props.row[orgStaffTags[key]]?.split(' ');

                if (match && nameArr && dateArr) {
                    arr.push({ value, match: nameArr[0], date: dateArr[0] });
                }
            }

            setValues(arr);
        }
    }, [props.row]);

    return (
        <>
            {values && values.length > 0 && (
                <Modal
                    trigger={
                        <Tooltip title="View people last saved">
                            <button type="button" className="btn btn-primary">
                                <Clipboard />
                            </button>
                        </Tooltip>
                    }
                    title="People last saved"
                    size="medium"
                >
                    <div>
                        <table className="table table-striped tabled-bordered">
                            <thead>
                                <tr>
                                    <th>Survey</th>
                                    <th>Person</th>
                                    {props.isOrgInfo && <th>Date</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {values.map((item, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{item.value}</td>
                                            <td>{item.match}</td>
                                            {props.isOrgInfo && <td>{item.date}</td>}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default LastUpdatedBy;
